import type { BLOG_WORDS_EN } from "./blog-words-en.ts";

export const BLOG_WORDS_ES: typeof BLOG_WORDS_EN = {
  footerLabel: "Blog",
  feedTitle: "Feed del blog",
  twinTitle: "Este artículo en markdown",
  eyebrow: "Blog",
  heading: "Cómo encontrar leads en Instagram",
  lede: "Cómo leer los seguidores y los seguidos de una cuenta, y qué hacer con un contacto público.",
  seoTitle: "Blog: cómo encontrar leads en Instagram",
  description:
    "Guías para encontrar leads en Instagram: qué cuenta como lead, de dónde sale el contacto y qué puedes hacer con él.",
  keyphrase: "encontrar leads en Instagram",
  all: "Todos",
  categoriesLabel: "Filtrar artículos por categoría",
  empty: "Todavía no hay artículos en este idioma.",
  featured: "Destacado",
  listTitle: "Artículos",
  categories: { guides: "Guías", "how-to": "Cómo hacerlo", product: "Producto", data: "Datos" },
  breadcrumbLabel: "Ruta de navegación",
  byline: "Por",
  published: "Publicado",
  updated: "Actualizado",
  faqTitle: "Preguntas",
  sourcesTitle: "Fuentes",
  relatedTitle: "Artículos relacionados",
  pagesTitle: "Ponlo en práctica",
};
